/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysQuePopupComponent } from './sysque-frame.component';

@NgModule({
  declarations: [SysQuePopupComponent],
  imports: [CommonModule],
  exports: [SysQuePopupComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueFrameModule {}
